<template>
  <div class="loading">
    <h1>404</h1>
    <p>您输入的地址有误，或该页面已变更</p>
  </div>
</template>

<script>
export default {

  name: 'not-found'

}
</script>

<style lang="less" scoped>
  @import '~@/styles/loading.less';
  
  .loading {
    color: white;
  }
</style>



// WEBPACK FOOTER //
// not-found.vue?29ed01dd